import JSRouter from "adminPage/JSRouter";
import {EVENT_EDITING_STOPPED, EVENT_TOOLBAR_ITEMS} from "content/ContentPost";

JSRouter.register('sk8House', new RegExp('^/cancellations/?'), (url_args) => {

    setTimeout(() => {
        let editor = $('body').data('editor');

        editor.on(EVENT_EDITING_STOPPED, () => editor.startEditing()).on(EVENT_TOOLBAR_ITEMS, ({left}) => {
            left.pop();
        });

        editor.startEditing();

    });

});